import CONSTANTS from './constants'

export default {
  [CONSTANTS.AVAILABILITY_CONSTANTS.AVAILABILITY]: {
    [CONSTANTS.AVAILABILITY_CONSTANTS.PAGE]: {},
    [CONSTANTS.AVAILABILITY_CONSTANTS.SEARCH]: {},
  },
  [CONSTANTS.DETAILPAGE_URL]: undefined,
  [CONSTANTS.DETAIL_DATASHEETS]: {},
  // [CONSTANTS.CATALOGTREEPAGE_URL]: undefined,
  [CONSTANTS.CATALOGTREE_PATH]: {},
  [CONSTANTS.CATALOGTAB_ID]: undefined,
  [CONSTANTS.PRODUCTS_REQUEST_PARAMS]: undefined,
  [CONSTANTS.PRODUCT_REQUEST_PARAMS]: undefined,
  [CONSTANTS.QUICKBUY_LIST]: {},
  [CONSTANTS.SNSEARCH_LIST]: {},
}
